// extracted by mini-css-extract-plugin
export var footer = "_m6-5";
export var fulfillmentInput = "_m6-0";
export var shipDateInput = "_m6-1";
export var shipmentModal = "_m6-2";
export var shipmentModalContent = "_m6-3";
export var tableContainer = "_m6-4";